export const CalcTypesPurchaseEnum = {
  TOTAL_ATTRIBUTES: 0,
  TOTAL_COMMON: 1,
  TOTAL_DESC_BASED_ON_ITEM: 2,
  TOTAL_DESC_BASED_ON_TOTAL: 3,
  TOTAL_NF: 4,
  TOTAL_TAX_REGIME: 5,
};

export const CalcTypesNFSeEnum = {
  TOTAL_SERVICES: 0,
  TOTAL_NF: 1,
  TAXES_BASED_ON_SERVICES: 2,
  TAXES_BASED_ON_TOTAL: 3,
  DISCOUNT_BASED_ON_SERVICES: 4,
  DISCOUNT_BASED_ON_TOTAL: 5,
};
